import { FC, useCallback, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useTranslation } from 'react-i18next'

import { CardRenderer, CardsRow } from '../'
import { FEATURE_CARDS } from '../../DiscoverAppsModal.constant'
import styles from './DiscoverModalContent.module.scss'

export const DiscoverModalContent: FC = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'discover_apps'
  })

  const { apps } = useAvailableApps()

  const handleTourClick = useCallback(
    (appId: AppId | undefined) => {
      if (!appId) return
      const appPath = apps[appId].path
      if (!appPath) return

      window.open(appPath, '_blank', 'noopener,noreferrer')
    },
    [apps]
  )

  const handleTellMeMoreClick = useCallback((_cardId: string) => {
    // TODO: Implement tell me more functionality
  }, [])

  const { firstRowCards, secondRowFirstTwo, secondRowThird } = useMemo(() => {
    const firstRow = FEATURE_CARDS.filter(card => card.row === 1)
    const secondRow = FEATURE_CARDS.filter(card => card.row === 2)
    const secondRowFirstTwo = secondRow.slice(0, 2)
    const secondRowThird = secondRow.slice(2)

    return {
      firstRowCards: firstRow,
      secondRowFirstTwo,
      secondRowThird
    }
  }, [])

  return (
    <div className={styles.discoverAppsBody}>
      <div className={styles.cardsContainer}>
        {/* First Row */}
        <CardsRow>
          {firstRowCards.map(card => (
            <CardRenderer
              key={card.id}
              card={card}
              title={t(card.titleKey)}
              featureName={t(card.featureNameKey)}
              heading={t(card.headingKey)}
              description={t(card.descriptionKey)}
              onTourClick={() => handleTourClick(card.appId)}
              onTellMeMoreClick={() => handleTellMeMoreClick(card.id)}
            />
          ))}
        </CardsRow>

        {/* Second Row */}
        <CardsRow>
          {secondRowFirstTwo.map(card => (
            <CardRenderer
              key={card.id}
              card={card}
              title={t(card.titleKey)}
              featureName={t(card.featureNameKey)}
              heading={t(card.headingKey)}
              description={t(card.descriptionKey)}
              onTourClick={() => handleTourClick(card.appId)}
              onTellMeMoreClick={() => handleTellMeMoreClick(card.id)}
            />
          ))}
          {secondRowThird.map(card => (
            <CardRenderer
              key={card.id}
              card={card}
              title={t(card.titleKey)}
              featureName={t(card.featureNameKey)}
              heading={t(card.headingKey)}
              description={t(card.descriptionKey)}
              onTourClick={() => handleTourClick(card.appId)}
              onTellMeMoreClick={() => handleTellMeMoreClick(card.id)}
              wrapperClassName={styles.thirdCardInSecondRow}
            />
          ))}
        </CardsRow>

        {/* Third Row (Mobile) */}
        {secondRowThird.length > 0 && (
          <CardsRow additionalClassName={styles.thirdRow}>
            {secondRowThird.map(card => (
              <CardRenderer
                key={card.id}
                card={card}
                title={t(card.titleKey)}
                featureName={t(card.featureNameKey)}
                heading={t(card.headingKey)}
                description={t(card.descriptionKey)}
                onTourClick={() => handleTourClick(card.appId)}
                onTellMeMoreClick={() => handleTellMeMoreClick(card.id)}
              />
            ))}
          </CardsRow>
        )}
      </div>
    </div>
  )
}
